import { BrowserRouter } from 'react-router-dom'
import { UseRoutes } from 'hooks/UseRoutes'
//
import './App.css'
import { Notify } from 'components'
import { useEffect } from 'react'


function App() {
	const routes = UseRoutes()

	useEffect(() => {
		document.title = 'Курултай 2025'
	}, [])

	return (
		<>
			<div className='App'>
				<BrowserRouter>{routes}</BrowserRouter>
				<Notify />
			</div>
		</>
	)
}

export default App
